module.exports = require("././angular-aria.js");


//////////////////
// WEBPACK FOOTER
// angular-aria (bower component)
// module id = 1417
// module chunks = 1